import { navSections } from "@/mocks/home";

const typeLinks = ["电影", "电视剧", "动作片", "科幻片", "经典老片", "悬疑片"];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-background-50 text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                神马影院
              </span>
            </div>
            <p className="mt-4 text-sm text-background-200/80 leading-relaxed">
              把电影、电视剧、动作片、科幻片、经典老片等按类型整理成片单，
              帮你在一个页面里快速找到想看的剧集或影片入口，节省到处搜索的时间。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#featured" className="cursor-pointer hover:text-primary-300 transition-colors">
                页面分区
              </a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {navSections.slice(0, 6).map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-background-200/80 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#featured" className="cursor-pointer hover:text-primary-300 transition-colors">
                类型速览
              </a>
            </h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {typeLinks.map((type) => (
                <a
                  key={type}
                  href="#featured"
                  className="inline-flex items-center h-7 px-2.5 rounded-md bg-secondary-800 text-xs text-background-200/90 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {type}
                </a>
              ))}
            </div>
            <p className="mt-5 text-sm text-background-200/80 leading-relaxed">
              片单条目由编辑按类型整理，仅作观影查找参考。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-200/70 font-label">
            © 2026 神马影院 · 影视片单资源导航
          </p>
          <p className="text-xs text-background-200/70 font-label">
            本页内容仅供影视信息整理与查找参考
          </p>
        </div>
      </div>
    </footer>
  );
}